import { useCallback } from 'react';
import { graphql, useMutation } from 'react-relay/hooks';
import { useOnboardingEventTrackingMutation } from './__generated__/useOnboardingEventTrackingMutation.graphql';

export type OnboardingEntryPoint = 'signup' | 'navigation';
export type OnboardingSelectionMode = 'fixed' | 'ai' | 'navigation';

type OnboardingEvent = {
    eventName: string;
    entryPoint: OnboardingEntryPoint;
    selectionMode?: OnboardingSelectionMode;
    currentSolution?: string;
    targetSolution?: string;
    promptText?: string;
    context?: Record<string, unknown>;
};

export function useOnboardingEventTracking() {
    const [commit] = useMutation<useOnboardingEventTrackingMutation>(graphql`
        mutation useOnboardingEventTrackingMutation($input: OnboardingEventInput!) {
            trackOnboardingEvent(input: $input)
        }
    `);

    return useCallback(
        (event: OnboardingEvent): Promise<void> =>
            new Promise((resolve) =>
                commit({
                    variables: {
                        input: {
                            eventName: event.eventName,
                            entryPoint: event.entryPoint,
                            payloadJson: JSON.stringify({
                                selectionMode: event.selectionMode,
                                currentSolution: event.currentSolution,
                                targetSolution: event.targetSolution,
                                promptText: event.promptText,
                                ...event.context
                            })
                        }
                    },
                    onCompleted: () => resolve(),
                    onError: () => resolve()
                })
            ),
        [commit]
    );
}
